import React from "react";

const ModifierTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">IMSA PAGE</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">The Weathertech SportsCar Championship, known as the Tudor United SportsCar Championship prior to 2016, was created when the NASCAR Grand-Am Series merged with the American Le Mans Series following the 2013 season.</p>
       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
            <tr style={{ width: "100%" }}>
             <th colspan="7" style={{ width: "100%",textAlign: "center",backgroundColor:'#EE1242' }}>SERIES CHAMPIONS</th>

              </tr>
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Prototype / GTP
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Prototype Challenge / LMP2	
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "10%" }}>
                LMP3
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                GT LeMans / GTD Pro
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                GT Daytona
                </th>
          
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>Pipo Derani Alexander Sims</td>
                <td style={{ textAlign: "center" }}>Ben Keating Paul-Loup Chatin</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>Jack Hawksworth Ben Barnicoat</td>
                <td style={{ textAlign: "center" }}>Bryan Sellers Madison Snow</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Oliver Jarvis Tom Blomqvist</td>
                <td style={{ textAlign: "center" }}>John Farano</td>
                <td style={{ textAlign: "center" }}>Jon Bennett Colin Braun</td>
                <td style={{ textAlign: "center" }}>Matt Campbell Mathieu Jaminet</td>
                <td style={{ textAlign: "center" }}>Roman DeAngelis</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Felipe Nasr Pipo Derani</td>
                <td style={{ textAlign: "center" }}>Ben Keating Mikkel Jensen</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Antonio Garcia Jordan Taylor</td>
                <td style={{ textAlign: "center" }}>Laurens VanthoorZacharie Robinson</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Helio Castroneves Ricky Taylor</td>
                <td style={{ textAlign: "center" }}>Patrick Kelly</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>Antonio Garcia Jordan Taylor</td>
                <td style={{ textAlign: "center" }}>Mario Farnbacher Matthew McMurry</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>11</td>
                <td style={{ textAlign: "center" }}>Pipo Derani Alexander Sims</td>
                <td style={{ textAlign: "center" }}>Ben Keating Paul-Loup Chatin</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>Jack Hawksworth Ben Barnicoat</td>
                <td style={{ textAlign: "center" }}>Bryan Sellers Madison Snow</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Oliver Jarvis Tom Blomqvist</td>
                <td style={{ textAlign: "center" }}>John Farano</td>
                <td style={{ textAlign: "center" }}>Jon Bennett Colin Braun</td>
                <td style={{ textAlign: "center" }}>Matt Campbell Mathieu Jaminet</td>
                <td style={{ textAlign: "center" }}>Roman DeAngelis</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>12</td>
                <td style={{ textAlign: "center" }}>Felipe Nasr Pipo Derani</td>
                <td style={{ textAlign: "center" }}>Ben Keating Mikkel Jensen</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Antonio Garcia Jordan Taylor</td>
                <td style={{ textAlign: "center" }}>Laurens VanthoorZacharie Robinson</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Helio Castroneves Ricky Taylor</td>
                <td style={{ textAlign: "center" }}>Patrick Kelly</td>
                <td style={{ textAlign: "center" }}>Gar Robinson</td>
                <td style={{ textAlign: "center" }}>Antonio Garcia Jordan Taylor</td>
                <td style={{ textAlign: "center" }}>Mario Farnbacher Matthew McMurry</td>
              </tr>
            
            </tbody>
          </table>
      
       
        </div>
      </section>
    </>
  );
};

export default ModifierTable;
